import api from '@/apiManager/apiManager'

export const getAllGroups = data => {
  const url = '/corporate-admin/group/all'
  return api('post', url, data, 'base')
}

export const getGroupActivityTypes = () => {
  const url = '/corporate-admin/group/activity_types'
  return api('get', url, '', 'base')
}

export const addGroup = data => {
  const url = '/corporate-admin/group/groups'
  return api('post', url, data, 'base')
}

export const deleteGroup = (id, changedById) => {
  const url = `/corporate-admin/group/${id}?changedById=${changedById}`
  return api('delete', url, '', 'base')
}
export const getGroup = id => {
  const url = `/corporate-admin/group/${id}`
  return api('get', url, '', 'base')
}

export const updateGroup = (data, id) => {
  const url = `/corporate-admin/group/${id}`
  return api('put', url, data, 'base')
}

export const getGroupParticipants = data => {
  const query = data.query ? `&query=${data.query}` : ''

  const url = `/corporate-admin/group/${data.id}/participants?limit=${data.limit}&offset=${data.offset}&status=${data.status}${query}`
  return api('get', url, '', 'base')
}

export const addGroupParticipants = (groupId, userIds) => {
  const url = `/corporate-admin/group/${groupId}/participants`
  return api('post', url, { userIds }, 'base')
}

export const removeGroupParticipants = data => {
  const url = `/corporate-admin/group/${data.group.id}/participants?participantIds=${data.id}`
  return api('delete', url, '', 'base')
}

export const updateGroupParticipants = data => {
  const url = `/corporate-admin/group/${data.id}/participants`
  return api('put', url, data, 'base')
}

export const getCSVGroupParticipants = data => {
  const url = `/corporate-admin/group/${data.id}/participants/export/csv?limit=${data.limit}&offset=0&status=accepted`
  return api('get', url, '', 'base')
}
